import React from "react";
import { motion } from "framer-motion";
import "./Catering.css";

const Catering = () => {
  return (
    <section id="catering" className="catering section">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Servering
        </motion.h2>

        <motion.p
          className="catering-intro"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          Vi gleder oss til å dele en deilig tapasmiddag og hjemmelaget drikke
          med dere
        </motion.p>

        <div className="catering-grid">
          <motion.div
            className="catering-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <div className="catering-icon">🍽️</div>
            <h3>Mat</h3>
            <p>
              Vi serverer et variert utvalg av tapas, desserter og kaker som
              skal smake alle.
            </p>
            <div className="menu-items">
              <p>
                <strong>Tapas:</strong> Kyllingklubber med aioli, friterte
                løkringer, bacondadler, tacoboller, kanaripotet med salsa,
                hvitløksreker, ostestikker, lefseruller, salat med dressing,
                nachos, focaccia med smør, cherrytomat, oliven, gulrot og
                selleri
              </p>
              <p>
                <strong>Dessert:</strong> Kommer senere
              </p>
              <p>
                <strong>Kaker:</strong> Et variert utvalg av hjemmelagde kaker
              </p>
            </div>
          </motion.div>

          <motion.div
            className="catering-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="catering-icon">🍷</div>
            <h3>Drikke</h3>
            <p>
              Vi har laget et utvalg av hjemmelagde viner, øl og cider, samt
              alkoholfrie alternativer.
            </p>
            <div className="menu-items">
              <p>
                <strong>Hvitvin:</strong> Riesling
              </p>
              <p>
                <strong>Rødvin:</strong> Pinot Noir og Merlot
              </p>
              <p>
                <strong>Øl:</strong> 2 typer lager
              </p>
              <p>
                <strong>Cider:</strong> Eple
              </p>
              <p>
                <strong>Alkoholfritt:</strong> Diverse brus og alkoholfritt øl
              </p>
              <p className="homemade-note">
                🏡 Vin, øl og cider er hjemmelaget
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Catering;
